import type { AxiosInstance } from 'axios';
import type {
  PlotSectionListResponse,
  ListQueryParams,
  EntityId,
} from '@/types';

export const getPlotSections = async (
  api: AxiosInstance,
  plot_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<PlotSectionListResponse> => {
  const resp = await api.get<PlotSectionListResponse>(`/plot/${plot_id}/section`, {
    params: { limit, start_key, name } as ListQueryParams,
  });
  return resp.data;
};

